/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_No_KeysInputs */

const en_settings_apikeys_no_keys = /** @type {(inputs: Settings_Apikeys_No_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API keys yet. Create one to get started.`)
};

const zh_settings_apikeys_no_keys = /** @type {(inputs: Settings_Apikeys_No_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有 API 密钥，创建一个开始使用。`)
};

/**
* | output |
* | --- |
* | "No API keys yet. Create one to get started." |
*
* @param {Settings_Apikeys_No_KeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_no_keys = /** @type {((inputs?: Settings_Apikeys_No_KeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_No_KeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_no_keys(inputs)
	return zh_settings_apikeys_no_keys(inputs)
});
export { settings_apikeys_no_keys as "settings.apikeys.no_keys" }